import { graphql } from '../../gql';

export const GET_QUOTE_EDITION = graphql(`
  query getQuoteEdition(
    $quoteUuid: String!
    $nextEdition: Boolean
    $previousEdition: Boolean
  ) {
    getQuoteEdition(
      quoteUuid: $quoteUuid
      nextEdition: $nextEdition
      previousEdition: $previousEdition
    ) {
      uniqueID
    }
  }
`);
